import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { HisSearchCriteriagroupComponentBase } from './his-search-criteriagroup.component';
import { HisSearchFormResultComponentBase } from './his-search-form-result.component';
import { HisSearchFormWidgetComponentBase } from './his-search-form-widget.component';
import { HisSearchFormComponentBase } from './his-search-form.component';
import { HisSearchSelectPopupComponentBase } from './his-search-select-popup.component';
import { HisSearchSelectComponentBase } from './his-search-select.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component( {
    selector: 'his-search-select',
    templateUrl: './his-search-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchSelectComponent extends HisSearchSelectComponentBase {
}

@Component( {
    selector: 'his-search-form-widget',
    templateUrl: './his-search-form-widget.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchFormWidgetComponent extends HisSearchFormWidgetComponentBase {
}

@Component( {
    selector: 'his-search-form',
    templateUrl: './his-search-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchFormComponent extends HisSearchFormComponentBase {
}


@Component( {
    selector: 'his-search-criteriagroup',
    templateUrl: './his-search-criteriagroup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchCriteriagroupComponent extends HisSearchCriteriagroupComponentBase {
}


@Component( {
    selector: 'his-search-form-result',
    templateUrl: './his-search-form-result.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchFormResultComponent extends HisSearchFormResultComponentBase {
}

export const HISSEARCHSELECTPOPUPCOMPONENT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HisSearchSelectPopupComponent),
    multi: true
};
@Component( {
    selector: 'his-search-select-popup',
    templateUrl: './his-search-select-popup.component.html',
    styleUrls: ['./his-search-select-popup.component.css'],
    providers: [HISSEARCHSELECTPOPUPCOMPONENT_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchSelectPopupComponent extends HisSearchSelectPopupComponentBase {
}
